const IntlMessageFormat = require('intl-messageformat');
/*
    labelMaker -
        Given a template, and variables, it will generate the combined string.
        It supports both passing in a list of values, or a map.
        Because there are currently Lingua values that are in these formats,
        this function must support them.

    Paramters:
        Translation - The lingua value, or string.
        'My Linga Value {0}'
        'My branch {1} Linga Value {0}'
        'Hello: {NAME}, welcome to {BRAND}'

    Example Uses:
    labelMaker('My Linga Value {0}', '5') =>  'My Lingua Value 5'
    labelMaker('My branch {1} Linga Value {0}', 'foo', 'bar') => 'My branch foo Linga Value bar'
    labelMaker('Hello: {NAME}, welcome to {BRAND}', {NAME: 'Phil', BRAND: 'HomeAway'}) => 'Hello: Phil, welcome to HomeAway'
*/
function labelMaker(translation = '', ...args) {
    let formattedMessage = '';
    let valueMap = args;
    let i = 0;

    if (Array.isArray(args) && args.length) {
        if (args.length === 1 && typeof args[0] === 'object') {
            valueMap = args[0];
        } else {
            valueMap = {};
            for (i; i < args.length; i++) {
                valueMap[i] = args[i];
            }
        }
    } else {
        return translation;
    }

    try {
        let intlMessageFormat = new IntlMessageFormat(translation);
        formattedMessage = intlMessageFormat.format(valueMap);
    } catch (e) {
        return translation;
    }
    return formattedMessage;
}

module.exports = {labelMaker};
